module.exports = __webpack_public_path__ + "static/img/txxq.53f3a50c.png";